/**
 报表管理--人效指标
 */

import React, { Component } from "react";
import { Progress, Tooltip, Popover } from "antd";
import { getCityList, userManagerRegionList, queryWorkEfficiency , geServiceCompanyListrOptions, getAuthUser } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import FormCore from "@/components/display/form/formCore";
import moment from "moment";
import PropTypes from "prop-types";
import PeoplePieChart from "@/pages/displayBoard/peoplePieChart";
import PeopleCountModel from "@/pages/displayBoard/peopleCountModel";
import PeopleZhuPage from "@/pages/displayBoard/peopleZhuPage";
// css
import "@/assets/stylus/displayBoard.styl";
// icon
import { QuestionCircleFilled, QuestionCircleOutlined } from "@ant-design/icons";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class PeopleTicketWorkCount extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubList;
    this.yunwei = this.props.intl.messages.commonBase;

    this.state = {
      pieData:[],
      barData:[],
      peopleData:[],
      userList:[
        {
          text: "全部",
          value: "",
        }],
      companyList:[
        {
          text: "全部",
          value: "",
        }],
        ticketTypeList:[
            {
                text: "全部",
                value: "",
            },{
                text: "故障工单",
                value: "11",
            },{
                text: "通用工单",
                value: "15",
            },{
                text: "调试工单",
                value: "13",
            },{
                text: "验收工单",
                value: "14",
            },{
                text: "巡检工单",
                value: "12",
            }],
          levelTypeList:[
            {
              text: "全部",
              value: "",
            },{
              text: "一般",
              value: "11001",
            },{
              text: "紧急",
              value: "11002",
            },{
              text: "重大",
              value: "11003",
            }],
      areaList:[
            {
              text: "全部",
              value: "",
            }],
      param: {
        cityIds: "",
        provinceIds: "000000", // 默认 000000全国
        date: '',
        operationProperty: "3",
        areaIds:"",
      },
      equipmentQry: {
        station: 0, // 桩群数量
        powerBox: 0, // 配电柜数量
        stub: 0, // 桩数量
      },
      successRate: "0",
      stubIntactRate: "0",
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  // 页面加载前方法
  componentWillMount() {
    this.setState({
      formConfig: this.initForm(),
    });
    this.getCityList();
    this.getEquipmentQry();
    this.getAreaList();
    this.getCompany();
    // this.getAuthUser();
  }

  // 页面加载完成方法
  componentDidMount() {}

  /**
   * 获取充电成功率数字
   */
  getSuccessRate = (value) => {
    this.setState({
      successRate: value,
    });
  };

  /**
   * 获取设备完好率数字
   */
  getStubIntactRate = (value) => {
    
    this.setState({
      stubIntactRate: value,
    });
  };

  /**
   * 获取负责的大区列表
   */
   getAreaList() {
     let that = this;
    fetchHandler(userManagerRegionList, {
      userId: sessionStorage.getItem("userId"),
    }).then((res) => {
      
      
      if (res.data) {
        res.data.forEach(function (item){
          item.text = item.regName;
          item.value = item.areaId;
        })
        res.data.unshift({
          text: "全部",
          value: "",
        })
        this.setState(
          {
            areaList:res.data,
          },
          () => {
            this.setState({
              formConfig: this.initForm(),
            });
          },
        );
      }
    });
  }

  /**
   * 获取执行人
   */
   getAuthUser() {
    let that = this;
   fetchHandler(getAuthUser, {
    pagecount: 100, relaType:1,page:1
   }).then((res) => {
     
     if (res.data) {
       res.data.forEach(function (item){
         item.text = item.userName + '(' + item.phone + ')';
         item.value = item.ctUserId;
       })
      res.data.unshift({
        text: "全部",
        value: "",
      })
       this.setState(
         {
          userList:res.data,
         },
         () => {
           this.setState({
             formConfig: this.initForm(),
           });
         },
       );
     }
   });
 }

  /**
   * 获取执行公司
   */
   getCompany() {
    let that = this;
   fetchHandler(geServiceCompanyListrOptions, {
     userId: sessionStorage.getItem("userId"), relaType:1
   }).then((res) => {
     
     if (res.data) {
       res.data.forEach(function (item){
         item.text = item.companyName;
         item.value = item.companyId;
       })
       res.data.unshift({
        value: "1",
        text: "开迈斯新能源科技有限公司",
      });
      res.data.unshift({
        text: "全部",
        value: "",
      })
       this.setState(
         {
           companyList:res.data,
         },
         () => {
           this.setState({
             formConfig: this.initForm(),
           });
         },
       );
     }
   });
 }

  /**
   * 获取人效指标数据
   */
  getEquipmentQry() {
    var date = this.state.param.date;
    if (date === '')
    {
      date =  [moment(new Date()).subtract(7, "d").format("YYYY-MM-DD"), moment(new Date()).subtract(1, "d").format("YYYY-MM-DD")];
    } else {
      date = date.split(",");
    }
    
    fetchHandler(queryWorkEfficiency, {
      startTime: date[0],
      endTime:date[1],
      userId: this.state.param.userId,
      companyId: this.state.param.companyId,
      levelType:this.state.param.levelType,
      ticketType:this.state.param.ticketType,
      cityIds: this.state.param.cityIds,
      areaIds:this.state.param.areaIds,
      provinceIds: this.state.param.provinceIds,
      isHourDetail:2,
    }).then((res) => {
      if (res.data) {
        //按照工单等级进行分组合并，用于饼图、柱状图和下面的人员数据展示  后台返回的是列表数据，列表是根据人员和工单类型分组的。
        var map = {};
        var people = {};
        var pieList = [];//工单等级统计数据
        var peopleData = [];//人员概览数据
        var colors = ['#40A9FF', '#FA8C16', '#CE0000', '#6A6AFF', '#64A600', '#FFFF6F'];
        var totalNum = 0;
        var response_time = 0;//响应时效
        var work_time = 0;//处理时效
        var look_time = 0;//验收时效
        var finish_time = 0;//总处理时效
        if (!res.data.workEfficiencyList || res.data.workEfficiencyList == null)
        {
          res.data.workEfficiencyList = [];
        }
        for(var i = 0; i < res.data.workEfficiencyList.length; i++){
          var ai = res.data.workEfficiencyList[i];
          response_time += ai.responseTime;
          work_time += ai.workTime;
          look_time += ai.lookTime;
          finish_time += ai.finishTime;
          for (var j = 0; j < res.data.levelList.length; j++)
          {
            if (ai.levelType == res.data.levelList[j].id)
            {
              ai.ticketPriorityName = res.data.levelList[j].name;
            }
          }
          totalNum += ai.ticketNum;
          if(!map[ai.levelType]){
            map[ai.levelType] = {
              levelType: ai.levelType,
              ticketPriorityName: ai.ticketPriorityName,
              totalNum:ai.ticketNum,
              totalHour:ai.hourNum
            };
          }else{
            map[ai.levelType].totalNum = map[ai.levelType].totalNum + ai.ticketNum;
            map[ai.levelType].totalHour = map[ai.levelType].totalHour + ai.hourNum
          }
          if(!people[ai.userId]){
            people[ai.userId] = {
              userId: ai.userId,
              username: ai.infoName,
              oneTime:ai.oneNum,
              totalNum:ai.ticketNum,
              totalHour:ai.hourNum,
              responseTime:ai.responseTime,
              workTime:ai.workTime,
              lookTime:ai.lookTime,
              finishTime:ai.finishTime,
            };
            
            people[ai.userId][ai.levelType] = ai.levelType;
            people[ai.userId][ai.levelType + 'name'] = ai.ticketPriorityName;
            people[ai.userId][ai.levelType + 'hour'] = ai.hourNum;
            people[ai.userId][ai.levelType + 'num'] = ai.ticketNum;
          }else{
            if (people[ai.userId][ai.levelType] != null)
            {
              people[ai.userId][ai.levelType + 'hour'] = people[ai.userId][ai.levelType + 'hour'] + ai.hourNum;
              people[ai.userId][ai.levelType + 'num'] = people[ai.userId][ai.levelType + 'num'] + ai.ticketNum;
            } else {
              people[ai.userId][ai.levelType] = ai.levelType;
              people[ai.userId][ai.levelType + 'name'] = ai.ticketPriorityName;
              people[ai.userId][ai.levelType + 'hour'] = ai.hourNum;
              people[ai.userId][ai.levelType + 'num'] = ai.ticketNum;
            }
            people[ai.userId].totalNum = people[ai.userId].totalNum + ai.ticketNum;
            people[ai.userId].totalHour = people[ai.userId].totalHour + ai.hourNum;
            people[ai.userId].oneTime = people[ai.userId].oneTime + ai.oneNum;

            people[ai.userId].responseTime = people[ai.userId].responseTime + ai.responseTime;
            people[ai.userId].workTime = people[ai.userId].workTime + ai.workTime;
            people[ai.userId].lookTime = people[ai.userId].lookTime + ai.lookTime;
            people[ai.userId].finishTime = people[ai.userId].finishTime + ai.finishTime;

          }
        }
        if (map != null)
        {
          var i = 0;
          for (var key in map) {
            map[key].rate = (map[key].totalNum / totalNum * 100).toFixed(2);
            map[key].color = colors[i];
            i++;
            pieList.push(map[key]);
          }
        }
      if (people != null)
        {
          var i = 0;
          for (var key in people) {
            //计算平均处理、响应、验收时长
            for (var keyM in map) {
              if (!people[key][keyM] || people[key][keyM] == null)
              {
                people[key][keyM] = map[keyM].ticketPriorityId;
                people[key][keyM + 'name'] = map[keyM].ticketPriorityName;
                people[key][keyM + 'hour'] = 0;
                people[key][keyM + 'num'] = 0;
              }
            }
            people[key].rate = (people[key].oneTime / people[key].totalNum * 100).toFixed(2) + '%';
            people[key].unitHour = (people[key].totalHour / people[key].totalNum).toFixed(2);
            people[key].color = colors[i];

            people[key].responseTime = ((people[key].responseTime / 3600) / people[key].totalNum).toFixed(2);
            people[key].workTime = ((people[key].workTime / 3600) / people[key].totalNum).toFixed(2);
            people[key].lookTime = ((people[key].lookTime / 3600) / people[key].totalNum).toFixed(2);
            people[key].finishTime = ((people[key].finishTime / 3600)).toFixed(2);
            i++;
            peopleData.push(people[key]);
          }
        }


        this.setState({
          pieData:pieList,
          peopleData:{
            peopleData:peopleData,
            pieList:pieList,
            pType:6
          },
          equipmentQry: {
            totalNum: res.data.totalNum,
            response_time:res.data.totalNum == 0 ? 0 : (response_time / 3600 / res.data.totalNum).toFixed(2),
            work_time:res.data.totalNum == 0 ? 0 : (work_time / 3600 / res.data.totalNum).toFixed(2),
            look_time:res.data.totalNum == 0 ? 0 : (look_time / 3600 / res.data.totalNum).toFixed(2),
            finish_time:res.data.totalNum == 0 ? 0 : (finish_time / 3600 / res.data.totalNum).toFixed(2),
            totalHour: res.data.totalHour,
            averageHour: res.data.averageHour,
            priorityNameList:res.data.priorityNameList,

          },
        });
      }
    });
  }

  /**
   * 获取城市数据
   */
  getCityList = () => {
    fetchHandler(getCityList, {userId:sessionStorage.getItem("userId")}).then((res) => {
      if (!res.data) {
        return;
      }
      const fetchPickerOptions = res.data;
      let formatOptionsStr = JSON.stringify(fetchPickerOptions);
      formatOptionsStr = formatOptionsStr.replace(new RegExp("label", "g"), "title");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("value", "g"), "value");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("children", "g"), "children");
      const cityAryy = JSON.parse(formatOptionsStr);
      cityAryy.map((item) => {
        item.key = item.value;
        item.children.map((item2) => {
          item2.key = item2.value;
          delete item2.children; // 删除子区域数据
          return true;
        });
        return true;
      });
      // 初始化城市数据
      this.quanguoCityArry = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];

      // 只能选择城市的方式
      this.quanguoCityNotP = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotP.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = false;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择省份的数组
      this.quanguoCityNotCity = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotCity.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = false;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择全国的数组
      this.quanguoCityNotChild = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotChild.map((item) => {
        item.disabled = false;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    });
  };

  changeCityData = (value) => {
    if (value.length === 0) {
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    }
    if (value.length === 1) {
      let quanguoCityArryCVal = '';
      if (value[0] === "000000") {
        quanguoCityArryCVal = this.quanguoCityNotChild;
      } else if (value[0].charAt(5) === "0" && value[0].charAt(4) === "0" && value[0].charAt(3) === "0" && value[0].charAt(2) === "0") {
        quanguoCityArryCVal = this.quanguoCityNotCity;
      } else {
        quanguoCityArryCVal = this.quanguoCityNotP;
      }
      // 设置数据
      this.setState(
        {
          quanguoCityArry: quanguoCityArryCVal,
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    }
  };

  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.props.onAdd(e, param);
  };

  // 加载form方法
  initForm() {
    const formConfig = {
      childItems: [
        {
          type: "select",
          placeholder: "请选择", // '请选择大区',
          labelName: "大区", // '大区',
          param: {
            name: "areaIds",
            type: "string",
          },
          options: this.state.areaList,
          allowClear: true,
          required: false,
          onChange: async (value, form) => {
            if (value == null || value == '')
            {
              //恢复区域信息
              form.setFieldsValue({
                cityGroup:[]
              });
            } else {
              //遍历区域，把不属于
              form.setFieldsValue({
                cityGroup:value.split(',')
              });
            }
            this.setState({
              formConfig: this.initForm(value),
            });
          },
        },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          param: {
            name: "cityGroup",
            type: "array",
          },
          onChange: this.changeCityData,
          data: this.state.quanguoCityArry,
          treeCheckable: true,
          treeCheckStrictly: false,
          showCheckedStrategy: "SHOW_PARENT",
          labelName: "地区",
          required: false,
        },

        {
          type: "select",
          placeholder: "请选择", 
          labelName: "执行公司", 
          param: {
            name: "companyId",
            type: "string",
          },
          options: this.state.companyList,
          allowClear: true,
          required: false,
        },

        {
          type: "select",
          placeholder: "请选择", 
          labelName: "工单类型", 
          param: {
            name: "ticketType",
            type: "string",
          },
          options: this.state.ticketTypeList,
          allowClear: true,
          required: false,
        },

        {
          type: "select",
          placeholder: "请选择", 
          labelName: "工单等级", 
          param: {
            name: "levelType",
            type: "string",
          },
          options: this.state.levelTypeList,
          allowClear: true,
          required: false,
        },

        {
          type: "select",
          placeholder: "请选择", // '请选择执行人',
          labelName: "执行人", // '执行人',
          param: {
            name: "userId",
            type: "string",
          },
          mapKey: {
            label: "label",
            value: "value",
          },
          options: this.state.userList,
          allowClear: true,
          required: false,
        },

        {
          type: "date",
          dateType: "rangeDate",
          placeholder: [
            '开始时间',
            '结束时间',
          ],
          param: {
            name: "date",
            type: "array",
          },
          width: "200px",
          allowClear: false,
          defaultValue:
            this.state.param.date === ""
              ? [moment(new Date()).subtract(7, "d"), moment(new Date()).subtract(1, "d")]
              : [moment(this.state.param.date).subtract(7, "d"), moment(this.state.param.date)],
          validator: {
            // 日期自定义校验规则
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            max_val: 31, // 最大可选天数
          }, // 自定义校验规则
          labelName: '时间范围', // '订单结束时间:',
          required: !1,
        },
        
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              text: "查询",
              // icon: "search",
              handler: (e, param) => {
                // 设置城市数组
                let cityIds = "";

                if (param.cityGroup) {
                  param.cityGroup.map((item) => {
                      cityIds += `${item},`;
                      return true;
                  });
                }
                // 判断选择地区类型（全国、省份、城市）
                let cityType = "0"; // 0：全国，1：省份，2：城市
                if (param.cityGroup !== undefined) {
                  if (param.cityGroup.length === 0) {
                    cityType = "0";
                    cityIds = "000000";
                  } else if (param.cityGroup[0] === "000000") {
                    cityType = "0";
                  } else if (
                    param.cityGroup[0].charAt(5) === '0'
                    && param.cityGroup[0].charAt(4) === '0'
                    && param.cityGroup[0].charAt(3) === '0'
                    && param.cityGroup[0].charAt(2) === '0'
                  ) {
                    cityType = "1";
                  } else {
                    cityType = "2";
                  }
                }
                this.setState(
                  {
                    param: {
                      cityIds: cityType === "2" ? (cityIds || "") : "",
                      provinceIds: cityType === "0" || cityType === "1" ? (cityIds || "000000") : "",
                      date: param.date,
                      areaIds:param.areaIds,
                      ticketType:param.ticketType,
                      levelType:param.levelType,
                      operationProperty: "3",
                      userId:param.userId,
                      companyId:param.companyId
                    },
                  },
                  () => {
                    // 查询设备数据
                    this.getEquipmentQry();
                  },
                );
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        operationProperty: "3",
      },
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "oprationLogTable",
    };

    return formConfig;
  }

  // style={{ "min-width": "1440px" }}
  render() {
    const content = (
      <div className='sc-page-content display-board-page'>
        <div className='page-toolbar'>
          <FormCore formConfig={this.state.formConfig} />
        </div>
        <div className='page-panel'>
          <div className='display-board'>
            <div className='item'>
              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                 
                  <div className='stub-info-item'>
                    <div className='name'>
                      工单总数{" "}
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>电站为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.equipmentQry.totalNum}</div>
                  </div>
                </div>
              </div>

              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                      平均响应时效(时)
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>配电柜为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.equipmentQry.response_time}</div>
                  </div>
                </div>
              </div>

              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                      平均处理时效(时)
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>配电柜为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.equipmentQry.work_time}</div>
                  </div>
                </div>
              </div>
              
            </div>

            <div className='item'>

              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                      平均验收时效(时)
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>配电柜为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.equipmentQry.look_time}</div>
                  </div>
                </div>
              </div>

              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                      平均总处理时效(时)
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>配电柜为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.equipmentQry.finish_time}</div>
                  </div>
                </div>
              </div>

              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                      工单处理总工时(时)
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>配电柜为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.equipmentQry.totalHour}</div>
                  </div>
                </div>
              </div>
              
            </div>
            <div className='item'>
              <div className='inner'  style={{ height: "421px" }}>
                <div style={{fontSize: '14px',fontWeight: '400'}} className="line-title">各等级工单处理数量占比图</div>
                <div  style={{ display: "flex", justifyContent:'center'}}>
                <PeoplePieChart getStubIntactRate={this.getStubIntactRate} chartId="glllPie" pieType="1" param={this.state.pieData} />
                </div>
              </div>
            </div>

            <div className='item'>
              <div className='inner' style={{ height: "421px"}}>
                
                <div style={{ flex: 1 }}>
                  <PeopleZhuPage getSuccessRate={this.getSuccessRate} param={this.state.pieData} />
                </div>
              </div>
            </div>
            
           
            <div className='item daochu' >
              <div className='inner' style={{ minHeight: "621px" }}>
                
                <div>
                <PeopleCountModel getStubIntactRate={this.getStubIntactRate} param={this.state.peopleData} />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
    return content;
  }
}

export default injectIntl(PeopleTicketWorkCount);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/peopleTicketWorkCount.js